import React from "react";
import { Col, Row } from "react-bootstrap";
import { formatPhoneNumber } from "react-phone-number-input";

import { AddressLine2Label } from "globalConstants";
import { ShippingMethodTypes } from "types/enums";

import TextBlock from "../components/textBlock";

type ShippingValues = {
	shipping_method: string;
	address: { [key: string]: string };
	phone_number: string;
	should_copy_shipping_address_to_merchant: boolean;
};

type ShippingViewViewProps = {
	shipping: ShippingValues;
};

const ShippingView = ({ shipping }: ShippingViewViewProps) => {
	const {
		shipping_method,
		address,
		phone_number,
		should_copy_shipping_address_to_merchant,
	} = shipping || {};
	return (
		<>
			<TextBlock
				label="Shipping Method"
				value={
					ShippingMethodTypes?.getByValue(+shipping_method)
						?.displayName
				}
				dataAutotest="Shipping Method"
			/>
			{should_copy_shipping_address_to_merchant && (
				<TextBlock
					iconCheck
					value="Save shipping address to merchant information"
					dataAutotest="isSaveshippingaddressToMerchantInfo"
				/>
			)}
			{ShippingMethodTypes?.getByValue(+shipping_method)?.value !==
				ShippingMethodTypes.none.value && (
				<>
					<Row>
						<Col xl={3}>
							<TextBlock
								label="Shipping Address 1"
								value={address?.address_line1}
								dataAutotest="shippingAddress1"
							/>
						</Col>
						<Col xl={3}>
							<TextBlock
								label={AddressLine2Label}
								value={address?.address_line2}
								dataAutotest="shippingAddress2"
							/>
						</Col>
						<Col xl={3}>
							<TextBlock
								label="City"
								value={address?.city}
								dataAutotest="city"
							/>
						</Col>
						<Col xl={3}>
							<TextBlock
								label="State"
								value={address?.region_code}
								dataAutotest="state"
							/>
						</Col>
					</Row>
					<Row>
						<Col xl={3}>
							<TextBlock
								label="Zip"
								value={address?.postal_code}
								dataAutotest="zip"
							/>
						</Col>
						<Col xl={3}>
							<TextBlock
								label="Country"
								value={address?.country}
								dataAutotest="country"
							/>
						</Col>
						<Col xl={3}>
							<TextBlock
								label="Phone"
								value={formatPhoneNumber(phone_number)}
								dataAutotest="shippingPhoneNumber"
							/>
						</Col>
					</Row>
				</>
			)}
		</>
	);
};

export default ShippingView;
